<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              {{ $t('gr302.pin') }}
            </div>
          </section>
          <section class="section02" v-if="false">
            <div class="object01"></div>
            <div class="object02" v-show="userInfo.userRole !== 'ClubManager'">
              <div class="form">
                <div class="formSelect" ref="select01">
                  <!--<div class="formSelectList" @click="openSelect01">-->
                  <div class="formSelectList">
                    <input type="text" v-model="currentClubInfo.club_name" :placeholder="$t('gr302.selectGolfClubPlaceholder')" readonly />
                  </div>
                  <div class="formSelectPopup typeSearch select01">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" :placeholder="$t('gr302.selectGolfClubPlaceholder')" v-model="searchValue" v-on:keyup="changeSearchValue" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                                  <label>
                                    <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                                  {{ $t('common.cancel') }}
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                                  {{ $t('common.confirm') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section03">
            <!-- 기간별 핀 히스토리 활성(Class) : term -->
            <div class="object01 term">
              <div class="title">
                <ul class="list">
                  <li class="time" @click="moveMenu(`/GR301` + getCurrentCcodeParam())">
                    {{ $t('gr302.realTimePinPosition') }}
                  </li>
                  <li class="term" @click="closeSelectAll">
                    {{ $t('gr302.periodPinPosition') }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="object02">
              <div class="formSelect" ref="select02">
                <div class="formSelectList" @click="openSelect02">
                  <input type="text" :value="$t('gr302.periodPinPosition')" readonly />
                </div>
                <div class="formSelectPopup select02">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" :placeholder="$t('gr302.selectTypePlaceholder')" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li @click="moveMenu(`/GR301`)">
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ $t('gr302.realTimePinPosition') }}</span>
                                </label>
                              </li>
                              <li @click="closeSelectAll">
                                <label>
                                  <input type="radio" checked/>
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ $t('gr302.periodPinPosition') }}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                {{ $t('common.cancel') }}
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                {{ $t('common.confirm') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01"></div>
            <div class="object02">
              <div class="form">
                <ul class="month">
                  <!-- 활성(Class) : active -->
                  <li @click="setSearchPeriod(1)">
                    {{ $t('gr302.months', { n: 1 }) }}
                  </li>
                  <li @click="setSearchPeriod(3)">
                    {{ $t('gr302.months', { n: 3 }) }}
                  </li>
                  <li @click="setSearchPeriod(6)">
                    {{ $t('gr302.months', { n: 6 }) }}
                  </li>
                </ul>
                <div class="formCalendar">
                  <div class="formCalendarList">
                    <date-picker
                      v-model="dateRange"
                      type="date" range
                      :format="'YYYY-MM-DD'"
                      :clearable="false"
                      @change="updateValues"
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(1, emit)">
                            {{ $t('gr302.months', { n: 1 }) }}
                          </button>
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(3, emit)">
                            {{ $t('gr302.months', { n: 3 }) }}
                          </button>
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(6, emit)">
                            {{ $t('gr302.months', { n: 6 }) }}
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </div>
                </div>
                <div class="formSelect course" ref="select03">
                  <div class="formSelectList" @click="openSelect03">
                    <input type="text" v-model="currentCourseInfo.name" :placeholder="$t('common.course')" readonly />
                  </div>
                  <div class="formSelectPopup select03">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" :placeholder="$t('gr302.selectTypePlaceholder')" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                                  <label>
                                    <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect03()"/>
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>{{courseInfo.name}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel">
                                  {{ $t('common.cancel') }}
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm">
                                  {{ $t('common.confirm') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="formSelect hole" ref="select04">
                  <div class="formSelectList" @click="openSelect04">
                    <input type="text" v-model="currentHoleNo" :placeholder="$t('common.hole')" readonly />
                  </div>
                  <div class="formSelectPopup select04">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" :placeholder="$t('gr302.selectTypePlaceholder')" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="i in (currentCourseInfo.endIdx - currentCourseInfo.startIdx)" :key="i">
                                  <label>
                                    <input type="radio" v-model="selectHlidx" :value="((i-1) + currentCourseInfo.startIdx)" v-on:change="confirmSelect04()"/>
                                    <input type="checkbox"  />
                                    <i></i>
                                    <span>Hole {{viewHoleNo(i + currentCourseInfo.startIdx - 1)}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel">
                                  {{ $t('common.cancel') }}
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm">
                                  {{ $t('common.confirm') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section05 dev_headerLine">
            <div class="object01">
              <div class="content" :class="{mobileDoubleContent: mobileFlag && pinGroupListRight && pinPeriodData.imageInfo.rg}">
                <div class="pin" style="line-height: 0; text-align: center; font-size: 0;">
                  <div class="object"></div>
                  <div class="flagZone">
                    <div class="flagZoneLeft" :style="{'width': mapAreaSize + 'px'}">
                      <!-- 위치값(Style) : x, y 좌표 -->
                      <div class="flagObject" v-for="(pinInfo, i) in pinGroupListLeft" :key="i" :style="{'top': pinInfo.y+'px', 'left': pinInfo.x+'px', 'opacity': currentPin === pinInfo ? '1' : '0.2'}">
                        {{ $t('gr302.flag') }}
                      </div>
                    </div>
                    <div v-if="pinPeriodData.imageInfo.rg" class="flagZoneRight" :style="{'width': mapAreaSize + 'px'}">
                      <!-- 위치값(Style) : x, y 좌표 -->
                      <div class="flagObject" v-for="(pinInfo, i) in pinGroupListRight" :key="i" :style="{'top': pinInfo.y+'px', 'left': pinInfo.x+'px', 'opacity': currentPin === pinInfo ? '1' : '0.2'}">
                        {{ $t('gr302.flag') }}
                      </div>
                    </div>
                  </div>
                  <div class="greenImage" :style="{'background-image': pinPeriodData.imageInfo.lg ? `url(${pinPeriodData.imageInfo['lg'].imageUrl})` : '', 'width': mapAreaSize + 'px'}"></div>
                  <div v-if="pinPeriodData.imageInfo.rg" class="greenImage" :style="{'background-image': pinPeriodData.imageInfo.rg ? `url(${pinPeriodData.imageInfo['rg'].imageUrl})` : '', 'width': mapAreaSize + 'px'}"></div>
                </div>
              </div>
            </div>
            <div class="object02 scroll-body">
              <div class="object0201">
                <!-- 데이터 없을때(Class) : none -->
                <div class="body" :class="pinGroupList.length === 0 ? 'none' : ''">
                  <div class="table thead">
                    <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                    <div class="fixed grid" style="margin-left: -0px;">
                      <div class="unit">
                        {{ $t('gr302.totalCount', { n: pinPeriodData.pinList === undefined ? 0 : pinGroupList.length }) }}
                      </div>
                      <div class="contain">
                        <table>
                          <colgroup>
                            <col class="pin" />
                            <col class="date" />
                            <col class="time" />
                            <col class="durationTime" />
                          </colgroup>
                          <thead>
                          <tr>
                            <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                            <th class="pin">
                              <div class="item">
                                {{ $t('gr302.pin') }}
                              </div>
                            </th>
                            <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                            <th class="date">
                              <div class="item">
                                {{ $t('gr302.date') }}
                              </div>
                            </th>
                            <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                            <th class="time">
                              <div class="item">
                                {{ $t('gr302.time') }}
                              </div>
                            </th>
                            <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                            <th class="durationTime">
                              <div class="item">
                                {{ $t('gr302.duration') }}
                              </div>
                            </th>
                          </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="table tbody">
                    <div class="contain">
                      <table>
                        <colgroup>
                          <col class="pin" />
                          <col class="date" />
                          <col class="time" />
                          <col class="durationTime" />
                        </colgroup>
                        <tbody>
                        <tr v-for="(pinInfo, i) in pinGroupList" :key="i" @click="setPinGps(pinInfo)">
                          <td class="pin">
                            {{i+1}}
                          </td>
                          <td class="date">
                            {{setDateFormat(pinInfo.updateAt, 'YYYY-MM-DD')}}
                          </td>
                          <td class="time">
                            {{setDateFormat(pinInfo.updateAt, 'HH:mm')}} ~ {{setDateFormat(pinInfo.endAt, 'HH:mm')}}
                          </td>
                          <td class="durationTime" v-html="setDurationTime(pinInfo.updateAt, pinInfo.endAt)">
                          </td>
                        </tr>
                        </tbody>
                        <tbody class="none">
                        <tr>
                          <td colspan="4">
                            {{ $t('gr302.noData') }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup typeSearch select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr302.selectGolfClubPlaceholder')" v-model="searchValue" v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                      <label>
                        <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr302.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li @click="moveMenu(`/GR301` + getCurrentCcodeParam())">
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ $t('gr302.realTimePinPosition') }}</span>
                      </label>
                    </li>
                    <li @click="closeSelectAll">
                      <label>
                        <input type="radio" checked/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ $t('gr302.periodPinPosition') }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select03">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr302.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                      <label>
                        <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect03()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{courseInfo.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select04">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select04">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr302.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="i in (currentCourseInfo.endIdx - currentCourseInfo.startIdx)" :key="i">
                      <label>
                        <input type="radio" v-model="selectHlidx" :value="((i-1) + currentCourseInfo.startIdx)" v-on:change="confirmSelect04()"/>
                        <input type="checkbox"  />
                        <i></i>
                        <span>Hole {{viewHoleNo(i + currentCourseInfo.startIdx - 1)}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import {clubInfoService, commonService, gcsService, userService} from '../../router'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import { getLocalMomentFromKst } from '../../util/timezone'

export default {
  name: 'GR303',
  data () {
    return {
      sDate: '',
      eDate: '',
      pinPeriodData: {
        imageInfo: {},
        pinList: []
      },
      currentHoleInfo: {
        aplId: '',
        battery: '',
        grsel: 'L',
        hlidx: '',
        isActive: true,
        lat: '',
        lon: '',
        lowBattery: false,
        nhole: '',
        temp: null,
        updateAt: ''
      },
      dateRange: [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],
      mapAreaSize: 0,
      selectCourseId: '',
      selectHlidx: 0,
      currentHlidx: 0,
      pinGps: {
        lat: null,
        lon: null
      },
      pinList: [],
      pinGroupList: [],
      currentPin: {}
    }
  },
  created: function () {
    let fromDate = new Date().setDate(new Date().getDate() - 7)
    let toDate = new Date()
    this.sDate = moment(fromDate).format('YYYY-MM-DD')
    this.eDate = moment(toDate).format('YYYY-MM-DD')

    userService.getAll().then(response => {
      this.userInfo = response.data
      clubInfoService.getClubInfoList('active').then(response => {
        this.clubInfoList = response.data.clubInfoList
        this.selectClubInfoList = response.data.clubInfoList
        if (this.userInfo.userRole === 'ClubManager') {
          this.currentClubCode = this.userInfo.ccode
        } else {
          if (this.$route.query.ccode === undefined) {
            this.currentClubCode = this.clubInfoList[0].ccode
          } else {
            this.currentClubCode = this.$route.query.ccode
          }
          this.setClubInfo()
        }
        this.selectCcode = this.currentClubCode
        commonService.getCourseListByCcode(this.currentClubCode).then(response => {
          this.courseList = response.data.courseList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
          for (let i in this.courseList) {
            let holeCnt = this.courseList[i].endIdx - this.courseList[i].startIdx
            if (this.maxHoleCnt < holeCnt) this.maxHoleCnt = holeCnt
          }
          if (this.courseList[0] !== undefined) {
            this.currentCourseInfo = this.courseList[0]
            this.selectCourseId = this.currentCourseInfo.courseId
          }
          this.setData()
        }).catch(error => {
          console.log('getCourseListByCcode.err.===>', error)
        })
      }).catch(error => {
        console.log('getClubInfoListByStatusActive.err.===>', error)
      })
    })
  },
  mounted: function () {
    if (this.mobileFlag) {
      if (window.innerWidth > 1279) {
        this.mobileFlag = false
      }
    } else {
      if (window.innerWidth < 1280) {
        this.mobileFlag = true
      }
    }
    if (document.querySelector('.section05 .object01 .content .pin') === null) return
    this.mapAreaSize = document.querySelector('.section05 .object01 .content .pin').clientHeight
    window.addEventListener('resize', this.resizeEvt)
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    DatePicker
  },
  methods: {
    setData: function () {
      // 브라우저 로컬 날짜 범위를 KST 데이터로 커버하기 위해 앞뒤 1일씩 확장 조회 후 로컬 날짜로 필터
      let querySDate = moment(this.sDate, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD')
      let queryEDate = moment(this.eDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      gcsService.getPinPeriod(this.currentClubCode, this.currentHlidx, querySDate, queryEDate).then(response => {
        this.pinPeriodData = response.data.pinPeriodData
        this.setGroupPin()
      }).catch(error => {
        console.log('getPinPeriod.err.===>', error)
        this.pinGroupList = []
      })
    },
    getCurrentCcodeParam: function () {
      let currentCcode = localStorage.getItem('currentCcode')
      if (currentCcode) {
        return `?ccode=${currentCcode}`
      } else {
        return ''
      }
    },
    setGroupPin: function () {
      this.pinList = this.pinPeriodData.pinList.map(pin => {
        let pinPosition = {}
        if (pin.grsel === 'L' && this.pinPeriodData.imageInfo.lg) {
          pinPosition = this.pos2Pix(this.pinPeriodData.imageInfo.lg.points, pin.lat, pin.lon, this.mapAreaSize, this.mapAreaSize)
        } else if (pin.grsel === 'R' && this.pinPeriodData.imageInfo.rg) {
          pinPosition = this.pos2Pix(this.pinPeriodData.imageInfo.rg.points, pin.lat, pin.lon, this.mapAreaSize, this.mapAreaSize)
        }
        let updateAt = getLocalMomentFromKst(pin.updateAt)
        return {
          x: pinPosition.x,
          y: pinPosition.y,
          lat: pin.lat,
          lon: pin.lon,
          grsel: pin.grsel,
          updateAt: updateAt,
          endAt: moment(updateAt).add(pin.duration, 'minutes')
        }
      }).filter(pin => {
        let localDate = pin.updateAt.format('YYYY-MM-DD')
        return localDate >= this.sDate && localDate <= this.eDate
      })
      let distSum = 0
      let distList = []
      for (let i = 0; i < this.pinList.length - 1; i++) {
        if (!this.pinList[i + 1]) break
        let dx = this.pinList[i].x - this.pinList[i + 1].x
        let dy = this.pinList[i].y - this.pinList[i + 1].y
        let dist = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2))
        distList.push(dist)
        distSum += dist
      }
      let groupRangeList = distList.map((el, i) => el > distSum / this.pinList.length ? i : 0).filter(el => el)
      let pinGroup = {}
      this.pinGroupList = []
      for (let i = 0; i < this.pinList.length; i++) {
        pinGroup.x = pinGroup.x || this.pinList[i].x
        pinGroup.y = pinGroup.y || this.pinList[i].y
        pinGroup.updateAt = this.pinList[i].updateAt
        pinGroup.endAt = pinGroup.endAt || this.pinList[i].endAt
        pinGroup.grsel = pinGroup.grsel || this.pinList[i].grsel
        // 그룹핑 기준 index 또는 마지막 i 또는 grsel 바뀜 또는 시간 차이 5분 이상
        if (groupRangeList.indexOf(i) > -1 || i === this.pinList.length - 1 || this.pinList[i].grsel !== this.pinList[i + 1].grsel || moment.duration(this.pinList[i].updateAt.diff(this.pinList[i + 1].endAt)).asMinutes() > 5) {
          this.pinGroupList.push(pinGroup)
          pinGroup = {}
        }
      }
      if (this.pinGroupList.length > 0) {
        this.setPinGps(this.pinGroupList[0])
      }
    },
    getCourseData: function (hlidx) {
      return this.courseList.find(it => ((it.startIdx <= hlidx) && (it.endIdx > hlidx)))
    },
    viewHoleNo: function (hlidx) {
      let startIdx = this.getCourseData(hlidx) === undefined ? 0 : this.getCourseData(hlidx).startIdx
      return (hlidx - startIdx) + 1
    },
    confirmSelect01: function () {
      this.currentClubCode = this.selectCcode
      this.setClubInfo()
      this.selectHlidx = 0
      this.currentHlidx = this.selectHlidx
      commonService.getCourseListByCcode(this.currentClubCode).then(response => {
        this.courseList = response.data.courseList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
        this.currentCourseInfo = this.courseList[0]
        this.selectCourseId = this.currentCourseInfo.courseId
        this.setData()
      }).catch(error => {
        console.log('getCourseListByCcode.err.===>', error)
      })
      this.closeSelectAll()
    },
    confirmSelect03: function () {
      this.currentCourseInfo = this.courseList.find(it => it.courseId === this.selectCourseId)
      this.selectHlidx = this.currentCourseInfo.startIdx
      this.confirmSelect04()
      this.closeSelectAll()
    },
    confirmSelect04: function () {
      this.currentHlidx = this.selectHlidx
      this.setData()
      this.closeSelectAll()
    },
    setDurationTime: function (startTime, endTime) {
      let diff = moment.duration(endTime.diff(startTime))
      return `<strong>${diff.hours()}</strong>hr <strong>${diff.minutes()}</strong>min`
    },
    setEndTime: function (startTime, duration) {
      return moment(new Date(new Date(startTime).getTime() + duration * 60000)).format('HH:mm')
    },
    updateValues: function (dateRange) {
      this.sDate = moment(dateRange[0]).format('YYYY-MM-DD')
      this.eDate = moment(dateRange[1]).format('YYYY-MM-DD')
      this.setData()
    },
    setSearchPeriod: function (months, emit) {
      let fromDate = new Date(new Date().setMonth(new Date().getMonth() - months))
      let toDate = new Date()
      this.sDate = moment(fromDate).format('YYYY-MM-DD')
      this.eDate = moment(toDate).format('YYYY-MM-DD')
      this.dateRange[0] = fromDate
      this.dateRange[1] = toDate
      this.setData()
      emit(this.dateRange)
    },
    setPinGps: function (pinInfo) {
      this.currentPin = pinInfo
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          if (document.querySelector('.section05 .object01 .content .pin') === null) return
          this.mapAreaSize = document.querySelector('.section05 .object01 .content .pin').clientHeight
          this.setGroupPin()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          if (document.querySelector('.section05 .object01 .content .pin') === null) return
          this.mapAreaSize = document.querySelector('.section05 .object01 .content .pin').clientHeight
          this.setGroupPin()
        }
      }
    }
  },
  computed: {
    currentHoleNo: function () {
      return 'Hole ' + this.viewHoleNo(this.currentHlidx)
    },
    pinGroupListLeft: function () {
      return this.pinGroupList.filter(pin => pin.grsel === 'L')
    },
    pinGroupListRight: function () {
      return this.pinGroupList.filter(pin => pin.grsel === 'R')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gcs/GR302.vue